/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/*
 *
 * DispatchMappings ACTIONS
 *
 */

export const setMappingValueInvalid = (invalid = false) => ({
  type: 'SET_MAPPING_VALUE_INVALID',
  invalid
});
